import { AppChannel, Channel } from "@/config/channel"
import Link from "next/link"
import { SisalLogo } from "./sisal-logo"

type HomePageLogoLinkProps = {
  siteid?: Channel
}

export function HomePageLogoLink({
  siteid = AppChannel.PortaleWebFullResponsiveWwwSisalIt,
}: HomePageLogoLinkProps) {
  const pathname =
    siteid === AppChannel.PortaleWebFullResponsiveWwwSisalIt
      ? process.env.APP_MAIN_SITE_HOMEPAGE
      : null
  return (
    <Link href={{ pathname }} title="Sisal">
      <SisalLogo channel={siteid} />
    </Link>
  )
}
